/**
 * @file: 常量集合
 * @author: wangzhenhai02@baidu.com
 * @Date: 2022-05-11 11:22:32
 * @LastEditors: chenyingliao <chenyingliao@baidu.com>
 * @LastEditTime: 2024-03-28 15:46:57
 * @FilePath: /console-znzs/src/constants/index.js
 */
export const STATUS_MSG_MAP = {
    'PROCESSING': '处理中',
    'PENDING_FEEDBACK': '待您反馈',
    'TO_BE_EVALUATED': '待您评价',
    'FINISHED': '已完成',
};

export const STATUS_MAP = [
    {text: '处理中', value: 'PROCESSING'},
    {text: '待您评价', value: 'TO_BE_EVALUATED'},
    {text: '待您反馈', value: 'PENDING_FEEDBACK'},
    {text: '已完成', value: 'FINISHED'},
];

export const RATE_LABEL = [
    {
        name: '回复慢',
        isSelected: false,
    },
    {
        name: '问题未解决',
        isSelected: false,
    },
    {
        name: '态度差',
        isSelected: false,
    },
    {
        name: '规则不合理',
        isSelected: false,
    },
    {
        name: '产品功能差',
        isSelected: false,
    },
];

/**
 * 相关设计及端码
 * @description https://ku.baidu-int.com/knowledge/HFVrC7hq1Q/pKzJfZczuc/v3byE0p5qJ/e141074f353543#anchor-41d786d0-ad0c-11ed-a73e-05753aa4e5cc
 */
export const PLATFORM_KEY = 0b000001; // 1

/**
 * 输入框上方选择产品的提示语
 */
export const PRODUCT_SELECT_TIP = '选择准确的产品类型有助于智能助手更好地理解并回答您的问题';
